/** Topics aide admin complémentaires — BT-028-R2 (FR). */

export const helpTopicsAdminFr028R2 = {
  "admin-classes": {
    key: "admin-classes",
    screenLabel: "Classes / cours",
    purpose: "Gérer l'horaire hebdomadaire — données démo, horaires officiels en attente.",
    actions: ["Consulter et filtrer les cours.", "Ajouter ou modifier une séance démo.", "Vérifier dojo et instructeur assignés."],
    warning: "[DÉMO] — horaires officiels en attente du fichier client.",
    nextStep: "Vérifier les événements ou les présences légères.",
  },
  "admin-events": {
    key: "admin-events",
    screenLabel: "Événements",
    purpose: "Calendrier événements dojo — démo Phase 1.",
    actions: ["Rechercher un événement.", "Filtrer par type ou période.", "Consulter les détails démo."],
    warning: "[DÉMO] — pas d'inscriptions opérationnelles Phase 1.",
    nextStep: "Vérifier l'espace Sensei pour les mêmes événements.",
  },
  "admin-attendance": {
    key: "admin-attendance",
    screenLabel: "Présences",
    purpose: "Présences légères — consultation et saisie démo limitée.",
    actions: ["Filtrer par cours ou date.", "Consulter les présences enregistrées."],
    warning: "Présences opérationnelles hors Phase 1 — données démo uniquement.",
    nextStep: "Retourner aux classes pour le contexte horaire.",
  },
  "admin-progression": {
    key: "admin-progression",
    screenLabel: "Progression / ceintures / examens",
    purpose: "Suivi progression, référentiel ceintures et examens — démo.",
    actions: ["Consulter progression par étudiant.", "Référence ceintures Shotokan.", "Examens — placeholder Phase 1."],
    warning: "[DÉMO] — aucune validation officielle de grade.",
    nextStep: "Vérifier Shotokan pour titres et reconnaissances.",
  },
  "admin-accounts": {
    key: "admin-accounts",
    screenLabel: "Comptes",
    purpose: "Comptes staging et saisie des courriels officiels fournis par Gilles — aucun courriel inventé.",
    actions: [
      "Consulter les comptes staging temporaires (.local).",
      "Remplacer un courriel staging par un courriel officiel confirmé.",
      "Forcer le changement de mot de passe si nécessaire.",
    ],
    warning: "Aucun courriel officiel ne doit être inventé — saisie manuelle uniquement.",
    nextStep: "Utiliser Préparation liste officielle pour le gabarit envoyé à Gilles.",
  },
  "admin-official-list-prep": {
    key: "admin-official-list-prep",
    screenLabel: "Préparation liste officielle",
    purpose:
      "Gabarit de collecte pour recevoir de Gilles la liste officielle des personnes, courriels, rôles et dojos — import massif non activé.",
    actions: [
      "Télécharger le gabarit CSV (en-têtes seulement).",
      "Consulter les champs requis et valeurs autorisées.",
      "Après réception du fichier Gilles, saisir les courriels dans Comptes & accès.",
    ],
    warning: "Aucune donnée officielle ne doit être inventée. Import massif non activé.",
    nextStep: "Ouvrir Comptes & accès pour saisir les courriels officiels confirmés.",
  },
  "admin-roles": {
    key: "admin-roles",
    screenLabel: "Rôles",
    purpose: "Matrice rôles DojoOS / MartialCore — référence Phase 1.",
    actions: ["Consulter les rôles disponibles.", "Comparer droits Hanshi, Sensei, Sempai, Parent, Étudiant."],
    warning: "Référence démo — pas de RBAC serveur Phase 1.",
    nextStep: "Retourner aux Comptes pour tester un rôle.",
  },
  "admin-requests": {
    key: "admin-requests",
    screenLabel: "Demandes de compte",
    purpose: "Demandes soumises localement — pas d'approbation automatique.",
    actions: ["Filtrer par statut.", "Consulter une demande.", "Marquer traité (démo)."],
    warning: "[DÉMO] — aucune création de compte réelle.",
    nextStep: "Utiliser un compte démo pour tester immédiatement.",
  },
  "admin-communications": {
    key: "admin-communications",
    screenLabel: "Communications",
    purpose: "Module communications — placeholder DojoOS Phase 1.",
    actions: ["Consulter la structure du module.", "Repérer le périmètre démo."],
    warning: "Envoi réel hors Phase 1 — placeholder uniquement.",
    nextStep: "Vérifier l'espace Parent pour les communications autorisées.",
  },
  "admin-diagnostic-avatar": {
    key: "admin-diagnostic-avatar",
    screenLabel: "Diagnostic avatar",
    purpose: "Vérifier autoritairement la persistance photo (disque, base, /auth/me, instructeurs).",
    actions: [
      "Cliquer « Vérifier mon avatar » après un upload.",
      "Confirmer PASS avant Ctrl+F5.",
      "Utiliser « Réparer depuis le disque » si fichier présent mais DB vide.",
    ],
    checklist: [
      "POST /api/v1/avatars/profile = 200",
      "GET image avatar = 200",
      "/auth/me contient avatar_url",
      "Carte instructeur utilise le backend en staging hybride",
    ],
    mistakes: [
      "Se fier à un aperçu blob temporaire sans diagnostic PASS.",
      "Relancer db:seed sans vérifier la préservation avatar.",
    ],
    nextStep: "Téléverser une photo, valider PASS, puis Ctrl+F5 sur le header et /instructeurs.",
  },
};
